import React from "react";

import Article from "../../../sections/Article/Article";
import Banner from "../../../sections/Banner/Banner";

const overview = () => {
  return (
    <div>
      <Banner
        img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/maddie-monument.jpg"
        img_alt="Maddie in front of the Washington Monument"
      >
        <h1>Training Overview</h1>
      </Banner>
      <section>
        <Article>
          {/* <h2>The DTC Training Philosophy</h2> */}
          {/* <img
            src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/tom.jpg"
            alt="Tom"
          /> */}
          <p>
            Our mission is to use our platform to provide world class resources
            to as many people as possible.
          </p>
          <p>
            In collaboration with some of the top experts, practitioners, and
            professionals in the sport we have created a Virtual Performance
            Center that is accessible worldwide to anyone with a computer or a
            smartphone.
          </p>
          <p>
            <a href="/auth">Sign Up</a> to learn from our athletes, coaches,
            physical therapists, and other partners
          </p>
          <p>
            The DTC training philosophy follows the principles of T.R.A.C.K.
          </p>
          <h3>T.R.A.C.K.</h3>
          {/* <img
            src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/alex.jpg"
            alt="Alex"
          /> */}
          <ul>
            <li>
              <span className="b">Time:</span> Being able to put in consistent
              work over time is the easiest way to progress as a track athlete.
              Visit our <a href="/training/health">Running Health</a> section to
              learn how to stay strong and healthy.
            </li>
            <li>
              <span className="b">Range:</span> Learn how to train everything
              from sprinting to long running in our Training Methods section.
            </li>
            <li>
              <span className="b">Athleticism:</span> Great runners need to be
              great athletes first. Check out our exercise library to learn.
            </li>
            <li>
              <span className="b">Championship Thinking:</span> The mind leads
              the body. Our <a href="/training/mindset">Mindset</a> section
              offers practical tools on how to deal with some of the most common
              issues in the sport.
            </li>
            <li>
              <span className="b">Keep it easy:</span> We give precedence to
              principles above as they are simple and repeatable.
            </li>
          </ul>
        </Article>
      </section>
    </div>
  );
};

export default overview;
